module.exports = __webpack_public_path__ + "img/中国绿发.de184274.png";